var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { LINE_OF_BUSINESS_HEADER } from '../constants/headers';
import { O, pipe } from '../lib/EffectExports';
import { AUTH_ENDPOINT, UNAUTH_ENDPOINT } from '../constants/endpoints';
const createAuthLink = (lineOfBusiness, tokenPromise) => setContext((_, { headers }) => __awaiter(void 0, void 0, void 0, function* () {
    const tokenOption = yield tokenPromise;
    const authHeader = pipe(tokenOption, O.map(token => ({ authorization: `Bearer ${token}` })), O.getOrElse(() => ({})));
    const userIdHeader = process.env.NEXT_PUBLIC_USER_ID
        ? { 'x-spotify-userid': process.env.NEXT_PUBLIC_USER_ID }
        : {};
    const uri = O.isSome(tokenOption) ? AUTH_ENDPOINT : UNAUTH_ENDPOINT;
    return {
        uri,
        credentials: 'include',
        headers: Object.assign(Object.assign(Object.assign(Object.assign({}, headers), { [LINE_OF_BUSINESS_HEADER]: lineOfBusiness }), userIdHeader), authHeader),
    };
}));
export const createAuthenticatedClient = (lineOfBusiness, token) => new ApolloClient({
    link: createAuthLink(lineOfBusiness, token).concat(createHttpLink()),
    cache: new InMemoryCache(),
});
//# sourceMappingURL=graphqlClient.js.map